module.exports = __webpack_public_path__ + "img/fahrradbox_bike_ride.ad463030.jpg";